export default __webpack_public_path__ + "static/media/risk.79ffaa4a.svg";